var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eqs-confirm-dialog",attrs:{"el-class":_vm.elClass}},[(_vm.type)?_c('EqsDialog',_vm._b({attrs:{"value":_vm.value,"persistent":""},on:{"update:value":function($event){_vm.value=$event}}},'EqsDialog',{
            ..._vm.type,
            eqsType: ['default', _vm.type.eqsType],
            eqsDataType: ['default', _vm.type.eqsType],
            ..._vm.props
        },false)):_vm._e(),_c('div',{staticStyle:{"display":"none"},attrs:{"data-test":`${_vm.elClass}-${_vm.value}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }